import StoreModule from "../core/StoreModule";
import { StorageObjectState } from "./state";

class StorageObjectStore extends StoreModule<StorageObjectState> {
  protected state: StorageObjectState = {
    layoutSourceObject: null,
  };

  get layoutSourceObject() {
    return this.state.layoutSourceObject;
  }

  set layoutSourceObject(val: StorageObjectState["layoutSourceObject"]) {
    this.setState({ layoutSourceObject: val });
  }
}

export const $storageObject = StoreModule.singleton(StorageObjectStore);
